module.exports = __webpack_public_path__ + "media/images/map-5dd8b9cd3862b62bf9d3e1476e81a418.png";